/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MessageFCMRequest { 
    token?: string;
    tokens?: Array<string>;
    title: string;
    body: string;
    imageUrl?: string;
    data?: object;
    notificationType?: MessageFCMRequest.NotificationTypeEnum;
    androidChannelId?: string;
}
export namespace MessageFCMRequest {
    export type NotificationTypeEnum = 'mobile' | 'web' | 'all';
    export const NotificationTypeEnum = {
        Mobile: 'mobile' as NotificationTypeEnum,
        Web: 'web' as NotificationTypeEnum,
        All: 'all' as NotificationTypeEnum
    };
}


